module.exports = __webpack_public_path__ + "img/balkon.07a02e6d.jpg";